import moment from "moment";
import React, { FC, useEffect, useState } from "react";
import { Log } from "../../../core/entities/log";
import { Button } from "../../atoms/Button";
import { ButtonWrapper, Italic, ReschedStyle, Wrapper, Text } from "./elements";

type Props = {
  date: string;
  phase: string;
  onConfirm: () => void;
  onCancel: () => void;
  logs?: { id: string; logs: Log[] };
  interviewers?: string[];
};

const DateConfirmationModalBody: FC<Props> = ({
  date,
  phase,
  onConfirm,
  onCancel,
  logs,
  interviewers,
}) => {
  const [updatedLogs, setUpdatedLogs] = useState(0);

  useEffect(() => {
    let rescheduled = 0;
    logs?.logs?.forEach((log: any) => {
      if (log.hasOwnProperty("status")) {
        if (log.status === "Rescheduled") {
          rescheduled += 1;
        }
      }
    });
    setUpdatedLogs(rescheduled);
  }, [logs]);

  return (
    <>
      {updatedLogs > 0 && (
        <ReschedStyle>Rescheduled: {updatedLogs}</ReschedStyle>
      )}
      <Wrapper>
        <Text>Are you sure you want to set this date?</Text>
        <Text>
          Applicant is scheduled for {phase} on the following details:
          <br />
          Date: {moment(new Date(date)).format("MM/DD/YYYY")}
          <br />
          Time: {moment(new Date(date)).format("hh:mm A")}
          <br />
          Interviewers:{" "}
          {interviewers && interviewers.length > 1
            ? interviewers?.map(
                (interviewer) =>
                  `${
                    interviewer === interviewers[interviewers.length - 1]
                      ? " & "
                      : interviewer === interviewers[0]
                      ? ""
                      : ", "
                  }${interviewer}`
              )
            : interviewers && interviewers.length && interviewers[0]}
        </Text>
        <Italic>
          * After clicking Yes, ATS will send an email to the applicant.
        </Italic>
        <ButtonWrapper>
          <Button type={"primary"} id="cancel_btn" onClick={onCancel}>
            No
          </Button>
          <Button type={"primary"} id="confirm_btn" onClick={onConfirm}>
            Yes
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </>
  );
};

export default DateConfirmationModalBody;
